/**
 * Denna blir 2 kolumner på stor skärm
 */

import { cn } from "helpers/classNames";
import { ReactNode } from "react";

interface Props extends React.ComponentPropsWithoutRef<"dl"> {
  children?: ReactNode;
}

export const MultiColumnList = ({ children, className, ...rest }: Props) => (
  <dl
    className={cn(
      "grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-8 lg:grid-cols-3 xl:grid-cols-4",
      className,
    )}
    {...rest}
  >
    {children}
  </dl>
);

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  children?: ReactNode;
}
export const Item = ({ children, className, ...rest }: ItemProps) => (
  <div className={cn("flex flex-col", className)} {...rest}>
    {children}
  </div>
);

interface LabelProps extends React.ComponentPropsWithoutRef<"dt"> {
  children?: ReactNode;
}

export const Label = ({ children, className, ...rest }: LabelProps) => (
  <dt
    className={cn(
      "mb-0.5 text-base font-medium text-gray-950 sm:text-sm",
      className,
    )}
    {...rest}
  >
    {children}
  </dt>
);

interface ValueProps extends React.ComponentPropsWithoutRef<"dd"> {
  children?: ReactNode;
}

export const Value = ({ children, className, ...rest }: ValueProps) => (
  <dd
    className={cn("text-base font-normal text-gray-800 sm:text-sm", className)}
    {...rest}
  >
    {children}
  </dd>
);
